import { Button, Flex, Typography } from "antd"

export const SettingsApiKeysStepUi = () => {
  return (
    <Flex vertical>
      <Typography.Text>Here, you can generate your API key.</Typography.Text>
      <Typography.Text>
        <span style={{ color: "black" }}>
          <svg
            fill="currentColor"
            height="16"
            style={{ bottom: "-2px", position: "relative" }}
            viewBox="0 0 24 24"
            width="16"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
          </svg>
          Important: API keys grant full access to all platform features. Keep
          them secure and do not share them with unauthorized parties.{" "}
        </span>
      </Typography.Text>
    </Flex>
  )
}
